import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import CreateAdvancePaymentAdmin from "../components/finance/CreateAdvancePaymentAdmin";
import FinanceHub from "../components/finance/hub/FinanceHub";
import CreateDebtReceivable from "../components/finance/CreateDebtReceivable";
import EditDebtReceivable from "../components/finance/EditDebtReceivable";
import Receivable from "../components/finance/Receivable";
import ToPay from "../components/finance/ToPay";
import CreateDebtToPay from "../components/finance/CreateDebtToPay";
import EditDebtToPay from "../components/finance/EditDebtToPay";
import Aliquots from "../components/finance/Aliquots";
import CommonCosts from "../components/finance/CommonCosts";
import CreateCommonCosts from "../components/finance/CreateCommonCosts";
import CreateAliquot from "../components/finance/CreateAliquot";
import EditAliquot from "../components/finance/EditAliquot";
import {
  FinanceRouteProtected,
  ProtectedRoute,
} from "../helpers/ProtectedRoute";
import LegacyRouteRedirect from "../helpers/LegacyRouteRedirect";
import Payments from "../components/finance/Payments";
import PropertyPaymentDetail from "../components/finance/PropertyPaymentDetail";
import Advance from "../components/finance/Advance";
import MyService from "../components/finance/MyService";

import MyPaymentService from "../components/finance/MyPaymentService";
import ManagerServicePayment from "../components/finance/ManagerServicePayment";
import ManagerServicePaymentDetails from "../components/finance/ManagerServicePaymentDetails";
import CreateCommonIncome from "../components/finance/CreateCommonIncome";
import CommonIncome from "../components/finance/CommonIncome";
import ReserveFund from "../components/reserve/ReserveFund";
import CreateReserveFund from "../components/reserve/CreateReserveFund";
import CreatePaymentFund from "../components/reserve/CreatePaymentFund";

import CreateCommonCostsEdit from "../components/finance/CreateCommonCostsEdit";
import EditDebtToPayProvider from "../components/finance/EditDebtToPayProvider";
import CreateProviderPayment from "../components/finance/CreateProviderPayment";
import PaymentsProvider from "../components/finance/PaymentsProvider";
import PaymentsProviderPaid from "../components/finance/PaymentsProviderPaid";
import IndividualIncome from "../components/finance/IndividualIncome";
import CreateIndividualIncome from "../components/finance/CreateIndividualIncome";
import ReserveFundDetails from "../components/reserve/ReserveFundDetails";
import Reports from "../components/finance/Reports";
import IndividualCosts from "../components/finance/IndividualCosts";
import CreateIndividualCosts from "../components/finance/CreateIndividualCosts";
import CreateIndividualCostsEdit from "../components/finance/CreateIndividualCostsEdit";
import PaymentsCurrentProperty from "../components/finance/PaymentsCurrentProperty";
import PropertyPaymentCurrentDetail from "../components/finance/PropertyPaymentCurrentDetail";
import ReceivableProperties from "../components/finance/ReceivableProperties";
import PaymentsProperties from "../components/finance/PaymentsProperties";
import PropertyPaymentsDetail from "../components/finance/PropertyPaymentsDetail";
import ManagerServicePaymentManual from "../components/finance/ManagerServicePaymentManual";
import PropertyToPays from "../components/finance/PropertyToPays";
import PropertyToPaysAdmin from "../components/finance/PropertyToPaysAdmin";
import CreatePaymentReserveFund from "../components/finance/CreatePaymentReserveFund";
import CreateAccountPay from "../components/finance/CreateAccountPay";
import PaymentsProviderOne from "../components/finance/PaymentsProviderOne";
import SingleForm from "../components/finance/SingleForm";
import ReportsProperties from "../components/finance/ReportsProperties";
import ChartOfAccounts from "../components/finance/ChartOfAccounts";
import Ledger from "../components/finance/Ledger";
import AccountPlansList from "../components/finance/AccountPlansList";
import Journal from "../components/finance/Journal";
import AccountMovements from "../components/finance/AccountMovements";

const FinanceRoutes = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}/`} exact component={FinanceHub} />
    <FinanceRouteProtected
      path={`${url}/:id/account-movements/:accountId`}
      exact
      component={AccountMovements}
    />


    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service`}
      component={MyService}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge`}
      component={MyPaymentService}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge/payment`}
      component={ManagerServicePayment}
    />

    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge/pay`}
      component={ManagerServicePaymentManual}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge/:paymentId`}
      component={ManagerServicePaymentDetails}
    />

    <FinanceRouteProtected path={`${url}/advance`} exact component={Advance} />
    <FinanceRouteProtected
      path={`${url}/:id/advance/add`}
      exact
      component={CreateAdvancePaymentAdmin}
    />
    <Route path={`${url}/:id`} exact component={FinanceHub} />

    <FinanceRouteProtected
      path={`${url}/:id/receivable/properties`}
      exact
      component={Receivable}
    />
    <FinanceRouteProtected
      path={`${url}/:id/receivable/:property`}
      exact
      component={ReceivableProperties}
    />
    <FinanceRouteProtected
      path={`${url}/:id/receivable/topays/:properties`}
      exact
      component={PropertyToPays}
    />
    <FinanceRouteProtected
      path={`${url}/:id/receivable/property/:properties/pay/:pay`}
      exact
      component={PropertyToPaysAdmin}
    />
    <FinanceRouteProtected
      path={`${url}/:id/receivable/detail/:debtReceivedId`}
      exact
      component={EditDebtReceivable}
    />
    <ProtectedRoute
      path={`${url}/:id/receivable/create`}
      rols={["manager"]}
      component={CreateDebtReceivable}
    />
    <FinanceRouteProtected path={`${url}/:id/topay`} exact component={ToPay} />
    {/* <FinanceRouteProtected path={`${url}/:id/topay/:debtToPayId`} exact component={ProviderToPayDetail} /> */}
    <FinanceRouteProtected
      path={`${url}/:id/topay/edit/:debtToPayId`}
      exact
      component={EditDebtToPay}
    />
    <FinanceRouteProtected
      path={`${url}/:id/topay-provider/edit/:debtToPayId`}
      exact
      component={EditDebtToPayProvider}
    />
    <FinanceRouteProtected
      path={`${url}/:id/topay-provider/edit/:debtToPayId/payment`}
      exact
      component={CreateProviderPayment}
    />
    {/*    <ProtectedRoute
      path={`${url}/:id/topay/create`}
      rols={["manager"]}
      component={CreateDebtToPay}
    /> */}
    <ProtectedRoute
      path={`${url}/:id/topay/create`}
      rols={["manager"]}
      component={CreateAccountPay}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payments-provider`}
      exact
      component={PaymentsProvider}
    />
    {/*   <FinanceRouteProtected
      path={`${url}/:id/payments-provider/:provider`}
      exact
      component={PaymentsProviderOne}
    /> */}
    <FinanceRouteProtected
      path={`${url}/:id/payments-provider-paid`}
      exact
      component={PaymentsProviderPaid}
    />

    <FinanceRouteProtected
      path={`${url}/:id/aliquots`}
      exact
      component={Aliquots}
    />
    <FinanceRouteProtected
      path={`${url}/:id/aliquots/edit/:aliquotId`}
      exact
      component={EditAliquot}
    />
    <ProtectedRoute
      path={`${url}/:id/aliquots/create`}
      rols={["manager"]}
      component={CreateAliquot}
    />
    <FinanceRouteProtected
      path={`${url}/:id/individual-costs`}
      exact
      component={IndividualCosts}
    />
    <ProtectedRoute
      path={`${url}/:id/individual-costs/create`}
      rols={["manager"]}
      component={CreateIndividualCosts}
    />
    <ProtectedRoute
      path={`${url}/:id/individual-costs/edit/:individualId`}
      rols={["manager"]}
      component={CreateIndividualCostsEdit}
    />

    <FinanceRouteProtected
      path={`${url}/:id/common-costs`}
      exact
      component={CommonCosts}
    />
    <ProtectedRoute
      path={`${url}/:id/common-costs/create`}
      rols={["manager"]}
      component={CreateCommonCosts}
    />
    <ProtectedRoute
      path={`${url}/:id/common-costs/edit/:commonId`}
      rols={["manager"]}
      component={CreateCommonCostsEdit}
    />

    <ProtectedRoute
      path={`${url}/:id/payment-reserve-fund/create`}
      rols={["manager"]}
      component={CreatePaymentReserveFund}
    />

    <FinanceRouteProtected
      path={`${url}/:id/common-income`}
      exact
      component={CommonIncome}
    />
    <ProtectedRoute
      path={`${url}/:id/common-income/create`}
      rols={["manager"]}
      component={CreateCommonIncome}
    />

    {/* Ingresos individuales: sección oculta a pedido, ruta deshabilitada para
    que tampoco se pueda entrar escribiendo la URL directamente.
    <FinanceRouteProtected
      path={`${url}/:id/individual-income`}
      exact
      component={IndividualIncome}
    />
    <ProtectedRoute
      path={`${url}/:id/individual-income/create`}
      rols={["manager"]}
      component={CreateIndividualIncome}
    />
    */}

    <FinanceRouteProtected
      path={`${url}/:id/reserve-funds`}
      exact
      component={ReserveFund}
    />
    <ProtectedRoute
      path={`${url}/:id/reserve-funds/create`}
      rols={["manager"]}
      component={CreateReserveFund}
    />
    <ProtectedRoute
      path={`${url}/:id/payment-fund/create`}
      rols={["manager"]}
      component={CreatePaymentFund}
    />

    <ProtectedRoute
      path={`${url}/:id/reserve-funds/:reserveFundId(\\d+)`}
      rols={["manager"]}
      component={ReserveFundDetails}
    />

    <FinanceRouteProtected
      path={`${url}/:id/payments/properties`}
      exact
      component={PaymentsProperties}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payments/:property`}
      exact
      component={Payments}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payments/property`}
      exact
      component={PaymentsCurrentProperty}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payments/property/:propertyPayment`}
      exact
      component={PropertyPaymentCurrentDetail}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payment/:propertyPayment`}
      exact
      component={PropertyPaymentDetail}
    />
    <FinanceRouteProtected
      path={`${url}/:id/pay/:propertyPayment`}
      exact
      component={PropertyPaymentsDetail}
    />

    <FinanceRouteProtected
      path={`${url}/:id/reports`}
      exact
      component={Reports}
    />
    <ProtectedRoute
      path={`${url}/:id/account-plans`}
      exact
      rols={["manager"]}
      component={AccountPlansList}
    />
    <FinanceRouteProtected
      path={`${url}/:id/form`}
      exact
      component={SingleForm}
    />
    <FinanceRouteProtected
      path={`${url}/:id/accounts`}
      exact
      component={ChartOfAccounts}
    />

    <FinanceRouteProtected
      path={`${url}/:id/reports/properties`}
      exact
      component={ReportsProperties}
    />

    <LegacyRouteRedirect />
  </Switch>
);

FinanceRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(FinanceRoutes);
